import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider, Global } from '@mantine/core';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import './index.css';


ReactDOM.createRoot(document.getElementById('root')).render(
  <MantineProvider
    withGlobalStyles
    withNormalizeCSS
    theme={{
      primaryColor: 'cyan',
      colors: {
        cyan: [
          '#E3FAFC',
          '#C5F6FA',
          '#99E9F2',
          '#66D9E8',
          '#3BC9DB',
          '#22B8CF',
          '#15AABF',
          '#1098AD',
          '#0C8599',
          '#0B7285',
        ],
      },
    }}
  >
    {/* Set global styles including body background */}
    <Global
      styles={{
        body: {
          backgroundColor: '#ffffff', // Light gray background (change as you like)
        },
      }}
    />

    <Provider store={store}>
      <App />
    </Provider>
  </MantineProvider>
);
